<style scoped>
.wrapper {

    justify-content: center;
    align-items: center;
}
</style>

<template>
    <div class="row wrapper">
        <div class="form-success" id="form-success">
            <div class="form-success-bg"> </div>
            <div class="form-success-title">Спасибо за заявку! Скоро с вами свяжется наш менеджер.</div>
            <div class="form-success-subtitle">Ознакомьтесь с предложениями партнеров и получить займ-онлайн прямо
                сейчас</div>
            <div class="form-success-button">
                <a href="https://zaymstar.ru" target="_blank" rel="noopener noreferrer">
                    ОЗНАКОМИТЬСЯ
                </a>
            </div>

        </div>
    </div>
    <div></div>
    <div></div>
    <div>
    </div>
</template>

<script>

export default {
    name: 'Thanks',

    props: {
        formType: String,
        forwardPage: Function,
        backwardPage: Function,
        previousPagePromise: Promise,
    },

    mounted() {

    }
}
</script>
